import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { Form } from 'components/atoms/form';
import { Input, TextArea } from 'components/atoms/input';
import { queueMacrotask } from 'utils/macrotask';
import { CpModal } from '../../components/modal/cp-modal';

export const CpCreateNewConversationModal: React.FC<{
  isVisible?: boolean;
  onSubmit: (name: string, desc: string) => void;
  onCancel: (name: string, desc: string) => void;
  initialData?: {
    name: string;
    desc: string;
  };
  isUpdateMode?: boolean;
}> = ({ isVisible, onSubmit, onCancel, initialData, isUpdateMode }) => {
  const [name, setName] = React.useState(initialData?.name || '');
  const [desc, setDesc] = React.useState(initialData?.desc || '');

  useEffect(() => {
    setName(initialData?.name || '');
  }, [initialData?.name]);

  useEffect(() => {
    setDesc(initialData?.desc || '');
  }, [initialData?.desc]);

  return (
    <CpModal
      getContainer={() =>
        document.getElementById('cp-modal-root') as HTMLElement
      }
      wrapClassName="cp-create-new-conv-modal-wrap"
      visible={isVisible}
      okText={
        <FormattedMessage
          id={
            isUpdateMode
              ? 'projects.conversations.form.channel.update'
              : 'projects.conversations.form.channel.create'
          }
        />
      }
      onCancel={() => {
        onCancel(name, desc);
        queueMacrotask(() => {
          setName('');
          setDesc('');
        });
      }}
      title={<FormattedMessage id="projects.conversations.new_shared" />}
      onOk={() => {
        if (!name) {
          return;
        }
        onSubmit(name, desc);
        queueMacrotask(() => {
          setName('');
          setDesc('');
        });
      }}
    >
      <Form layout="vertical">
        <Form.Item
          label={
            <FormattedMessage id="projects.conversations.form.channel_name" />
          }
        >
          <Input value={name} onChange={(e) => setName(e.target.value)} />
        </Form.Item>
        <Form.Item
          label={
            <FormattedMessage id="projects.conversations.form.channel_description" />
          }
        >
          <TextArea
            value={desc}
            onChange={(e) => setDesc(e.target.value)}
            rows={4}
          />
        </Form.Item>
      </Form>
    </CpModal>
  );
};
